import { Route, Routes } from "react-router-dom";
import { RecipePage } from "./pages/RecipePage";

const RecipeModule = () => {
  return (
    <Routes>
      <Route index element={<RecipePage />} />
      <Route path=":recipeId" element={<RecipePage />} />
    </Routes>
  );
};
export default RecipeModule;
